import { render, staticRenderFns } from "./setting-mail.vue?vue&type=template&id=37f456f7"
import script from "./setting-mail.js?vue&type=script&lang=js&external"
export * from "./setting-mail.js?vue&type=script&lang=js&external"
import style0 from "./setting-mail.vue?vue&type=style&index=0&id=37f456f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports